import { render, staticRenderFns } from "./feePgsAppendix.vue?vue&type=template&id=3257a5a9&scoped=true"
import script from "./feePgsAppendix.vue?vue&type=script&lang=js"
export * from "./feePgsAppendix.vue?vue&type=script&lang=js"
import style0 from "./feePgsAppendix.vue?vue&type=style&index=0&id=3257a5a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3257a5a9",
  null
  
)

export default component.exports